import React, {Component} from 'react';
import MultipleDatePicker from 'react-multiple-datepicker';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Tabs, Tab} from 'material-ui/Tabs';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Badge from 'material-ui/Badge';
import moment from "moment";
import '../../asset/css/login.css';
import PageContentWallpaper from '../common/ef-pageContent';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import ReactHtmlTableToExcel from "react-html-table-to-excel";


import {connect} from 'react-redux'
import {GetUserToken, PostToBackend} from "../../api/services";
import eConfig from '../../config';
import {isSupperAdminUser} from "../../api/others";

class AttendanceNewComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            organisation: "",
            accountRef: "",
            username: "",
            Data: null,
            Wallets: [],
            Dealers: [],
            Agents: [],
            selectRow: null,

            startDate: new Date(),
            endDate: new Date(),

            selectedType: "",
            selectedData: [],
            showDetail: false,
            viewData: [],
            filterDetail: "",
        }

    }

    async  componentWillMount() {
        await isSupperAdminUser();
        const user = GetUserToken();
        this.setState({organisation: user.OrgCode, username: user.Username});
    }

    async componentDidMount() {
        await this.fetchDealer();
        //await this.fetchDealer();
        await this.fetchAgents();
    }

    handleChangeStartDate = (date) => {
        this.setState({
            startDate: date
        });
    }
    handleChangeEndDate = (date) => {
        this.setState({
            endDate: date
        });
    }
    handleChangeType = (e) => {
        let tmp = this.state;
        tmp["selectedType"] = e.target.value;
        this.setState(tmp);
    }
    convertDateFormat_YYYYMMDD = (datesIn) => {
        let myDate = moment(datesIn).format("YYYY-MM-DD");
        return myDate;
    }
    fetchWallet = async () => {
        let _this = this;
        let conds = [];
        this.fetchingAll("wallet", conds, (data) => {
            console.log("fetchWallet :> ", data);
            _this.setState({
                Wallets: data,
            });
        });
    }
    fetchDealer = async () => {
        let _this = this;
        let conds = [];
        this.fetchingAll("Dealership", conds, (data) => {
            console.log("fetchDealer :> ", data);
            let accountRef = _this.state.accountRef;
            const username = _this.state.username;
            for (let i in data) {
                const row = data[i];
                if (row.email === username) {
                    accountRef = row.ref;
                }
            }
            _this.setState({
                Dealers: data,
                accountRef: accountRef
            });
        });
    }
    fetchAgents = async () => {
        let _this = this;
        let conds = [];
        this.fetchingAll("agent", conds, (data) => {
            console.log("fetchAgents :> ", data);
            let accountRef = _this.state.accountRef;
            const username = _this.state.username;
            for (let i in data) {
                const row = data[i];
                if (row.email === username) {
                    accountRef = row.ref;
                }
            }
            _this.setState({
                Agents: data,
                accountRef: accountRef
            });
        });
    }
    fetchingAll = async (table, conds, callback) => {

        const user = GetUserToken();
        console.log("User :> ", user);

        let hub = {
            Fields: [],
            DbName: "chela",
            TableName: table,
            Conditions: conds,
        }
        //  /backend-ecare/api/global-service
        let backend = eConfig.mainBackend;
        let endpoint = "/api/global-service/list";

        console.log("fetchingAll send > ", table, hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("fetchingAll response > ", table, dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                callback(data);

            }
        });
    }
    submitSearchDashboard = async () => {
        let state = this.state;
        let _this = this;

        if (state.selectedType === "") {
            alert("Please select your report type!");
            return
        }

        let hub = {
            PreferenceRef: state.accountRef,
            DateRangeStart: this.convertDateFormat_YYYYMMDD(state.startDate),
            DateRangeEnd: this.convertDateFormat_YYYYMMDD(state.endDate),
            PreferenceType: state.selectedType
        };


        console.log("Submit submitSearchDashboard > ", hub);

        let backend = eConfig.mainBackend;
        let endpoint = "/api/macro-finance/dashboard/daily";


        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("Submit submitSearchDashboard response > ", dataIn);
            if (typeof dataIn.RESULT !== "undefined") {
                let tmp = _this.state;
                tmp.Data = dataIn.RESULT;
                _this.setState(tmp);
                //TODO reinitialize state
            }
        });

    }
    handleInput = (e, key) => {
        let tmp = this.state;
        tmp[key] = e.target.value;
        this.setState(tmp);
    }
    getValue = (key) => {
        if (typeof this.state[key] !== "undefined") {
            return this.state[key]
        }
        return "";
    }
    openViewDetail = (data, accName, accRef) => {
        this.setState({
            showDetail: true,
            viewData: data,
            filterDetail: "",
            selectedAccName: accName,
            selectedAccRef: accRef,
        });
    }
    closeShowDetail = () => {
        this.setState({
            showDetail: false,
            viewData: [],
            filterDetail: "",
            selectedAccName: "",
            selectedAccRef: "",
        })
    }

    renderDashboardSummary = () => {

    }
    renderDashboardDetail = () => {
        if (this.state.Data === null) {
            return null
        }

        let ls = [];
        let sale = 0, sold = 0, comm = 0, transferIn = 0, transferOut = 0, deposit = 0, topupIn = 0, topupOut = 0;
        for (let i in this.state.Data) {
            const row = this.state.Data[i];
            sale = sale + parseFloat(row.SaleAmount);
            sold = sold + row.Sale;
            transferIn = transferIn + parseFloat(row.TransferInAmount);
            transferOut = transferOut + parseFloat(row.TransferOutAmount);
            deposit = deposit + parseFloat(row.DepositAmount);
            topupIn = topupIn + parseFloat(row.TopupInAmount);
            topupOut = topupOut + parseFloat(row.TopupOutAmount);
            comm = comm + parseFloat(row.CommissionAmount);
            ls.push(row);
        }

        const innerStyle = {textAlign: "right"};

        return (
            <table className={"table"}>
                <thead>
                <tr>
                    <th>Account</th>
                    <th>Sold</th>
                    <th>Sale</th>
                    <th>Comm</th>
                    <th>Transfer-In</th>
                    <th>Transfer-Out</th>
                    <th>Deposit</th>
                    <th>Topup</th>
                    <th>#</th>
                </tr>
                </thead>

                <tbody>
                {ls.map((row, index) => {
                    return (
                        <tr>
                            <th>{row.AccountName} &nbsp; &nbsp; (<span
                                style={{color: "gray"}}>{row.AccountRef + " -- " + row.AccountCategory}</span>)
                            </th>
                            <td style={innerStyle}>{row.Sale}</td>
                            <td style={innerStyle}>{row.SaleAmount}</td>
                            <td style={innerStyle}>{row.CommissionAmount.toFixed(2)}</td>
                            <td style={innerStyle}>{row.TransferInAmount.toFixed(2)}</td>
                            <td style={innerStyle}>{row.TransferOutAmount.toFixed(2)}</td>
                            <td style={innerStyle}>{row.DepositAmount.toFixed(2)}</td>
                            <td style={innerStyle}>{row.TopupInAmount.toFixed(2)}</td>
                            <td style={innerStyle}>
                                <a
                                    className={"btn btn-default"}
                                    onClick={() => this.openViewDetail(row.Data, row.AccountName, row.AccountRef)}
                                >View</a> &nbsp;
                            </td>
                        </tr>
                    )
                })}
                </tbody>

                <tfoot>
                <tr style={{fontSize: 18, fontWeight: "bold", color: "red"}}>
                    <th>Total</th>
                    <th style={innerStyle}>{sold}</th>
                    <th style={innerStyle}>{sale.toFixed(2)}</th>
                    <th style={innerStyle}>{comm.toFixed(2)}</th>
                    <th style={innerStyle}>{transferIn.toFixed(2)}</th>
                    <th style={innerStyle}>{transferOut.toFixed(2)}</th>
                    <th style={innerStyle}>{deposit.toFixed(2)}</th>
                    <th style={innerStyle}>{topupIn.toFixed(2)}</th>
                    <th style={innerStyle}>&nbsp;</th>
                </tr>
                </tfoot>
            </table>
        )
    }

    renderShowDetail() {
        /*
        showDetail:false,
            viewData:[],
            filterDetail:"",
         */

        if (this.state.showDetail === false) {
            return null
        }

        const actions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onClick={this.closeShowDetail}
            />,
        ];

        let ls = [];
        let counter=0;
        let totalAmount=0;

        for (let i in this.state.viewData) {
            const row = this.state.viewData[i];
            console.log("renderShowDetail ----:> ", row);
            if (row.TransCategory=== "sale-debit") {
                //console.log("targetWorker:> ", row, " == ", targetWorker, " > ", (row.workerusername === targetWorker));
                ls.push(row);
                counter++;
                totalAmount = totalAmount + parseFloat(row.TransAmount);
            }

        }
        const cleanCurrency=(amountText)=>{
            const arr=amountText.split("R");
            let amount = amountText;
            if(arr.length > 0){
                amount=arr[1]
            }
            return amount;
        }
        const infoTitle = this.state.selectedAccName + " -- " + this.state.selectedAccRef;
        return (
            <MuiThemeProvider>
                <Dialog
                    title={"Detail Report ("+infoTitle+")"}
                    actions={actions}
                    modal={false}
                    open={this.state.showDetail}
                    onRequestClose={this.closeShowDetail}
                    autoScrollBodyContent={true}
                >
                    <h3 style={{color : "red"}}>
                        Total Sold: {counter} | Total Amount Sold: R{totalAmount}
                        <ReactHtmlTableToExcel
                            id="test-table-xls-button"
                            className="download-table-xls-button pull-right"
                            table="tbDetail01"
                            filename="tablexls"
                            sheet="tablexls"
                            buttonText="Download as XLS"

                        />
                    </h3>
                    <div className="col-lg-12">
                        <table className="table" id={"tbDetail01"}>
                            <thead>
                            <tr>
                                <th>msisdn</th>
                                <th>date</th>
                                <th>time</th>
                                <th>amount(incl Vat)</th>
                                <th>product</th>
                                <th>networkRef</th>
                                <th>parkCode</th>
                                <th>old B</th>
                                <th>new B</th>
                            </tr>
                            </thead>
                            <tbody>
                            {ls.map((row, i) => {
                                return (
                                    <tr key={"i" + i}>
                                        <td>{row.InRef}</td>
                                        <td>{row.TransDate}</td>
                                        <td>{row.TransTime}</td>
                                        <td style={{textAlign:"center"}}>{cleanCurrency(row.ExtRef)}</td>
                                        <td>{row.ProductType || "---"}</td>
                                        <td>{row.ApiRef || "---"}</td>
                                        <td>{row.ServicePackCode || "---"}</td>
                                        <td>{row.BalanceOld.toFixed(2) || "---"}</td>
                                        <td>{row.BalanceNew.toFixed(2) || "---"}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>


                </Dialog>

            </MuiThemeProvider>


        )

    }


    render() {
        return (


            <PageContentWallpaper {...this.props} >
                <MuiThemeProvider>

                    <div className="row">
                        <div className="col-xs-12">
                            <h2>Dashboard Date Range Report</h2>
                            <small>Your account: {this.state.accountRef}</small>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            <div className="form-row">
                                <div className="form-group col-md-3">
                                    <label htmlFor="inputState">Start Date</label>
                                    <DatePicker
                                        selected={this.state.startDate}
                                        onChange={this.handleChangeStartDate}
                                        className="form-control"
                                    />
                                </div>

                                <div className="form-group col-md-3">
                                    <label htmlFor="inputState">End Date</label>
                                    <DatePicker
                                        selected={this.state.endDate}
                                        onChange={this.handleChangeEndDate}
                                        className="form-control"
                                    />

                                </div>

                                <div className="form-group col-md-3">
                                    <label htmlFor="inputState">Type of report</label>
                                    <select
                                        onChange={(e) => this.handleChangeType(e)}
                                        className="form-control"
                                        value={this.getValue("selectedType")}
                                    >
                                        <option value={""}>--Select your Type--</option>
                                        <option value={"single"}>Personal</option>
                                        <option value={"dealer"}>Dealer</option>
                                        <option value={"all"}>All (Dealer & Agent)</option>
                                    </select>

                                </div>


                                <div className="form-group col-md-3">
                                    <label htmlFor="inputState">&nbsp;</label>
                                    <button
                                        className="form-control pull-right btn btn-default"
                                        onClick={() => this.submitSearchDashboard()}
                                    >Search
                                    </button>
                                </div>

                            </div>

                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">

                            <Tabs>
                                <Tab label="Detail">
                                    {this.renderDashboardDetail()}
                                </Tab>
                                <Tab label="Sumary">
                                    {this.renderDashboardSummary()}
                                </Tab>


                            </Tabs>

                        </div>


                    </div>
                    <div className={"row"}>
                        <div className="col-xs-12">
                            {this.renderShowDetail()}
                        </div>
                    </div>

                </MuiThemeProvider>

            </PageContentWallpaper>


        );
    }
}


const mapDispatchToProps = dispatch => ({
    dispatch: dispatch
})

const mapStateToProps = state => ({
    addingModel: state.addingModel,
    login: state.login
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AttendanceNewComponent)
